<template>
	<div class="sf-datatable-wrapper">
		<div class="sf-datatable-container">
			<div class="sf-card__header mt-3">
				<div class="d-flex align-items-end">
					<!--审批评论-->
					<span class="title"><i class="sf-icon icon-sf-caret-right" />{{ getMessage_('QWCC002144') }}</span> 
				</div>
			</div>

			<template>
				<sf-data-table
					ref="apprCmntTable"
					:paging="false"
					:columns="apprCmntCols"
					:rows="tableData"
					:excel="false"
					:stripe="false"
					fit
				>
				</sf-data-table>
			</template>
		</div>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../../store/helpers';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		tableData() {
			return this.roApcnCommentList;
		},
		apprCmntCols() {
			return [
				{
					label: this.getMessage_('QWCC002145'),
					prop: 'userName',
					width: '200px',
					align: 'center',
					sortable: false
				},
				{
					label: this.getMessage_('QWCC000978'),
					prop: 'rsltNm',
					width: '200px',
					align: 'center',
					sortable: false
				},
				{
					label: this.getMessage_('MWPE000025'),
					prop: 'content',
					minWidth: '300px',
					sortable: false
				},
				{
					label: this.getMessage_('QWCC002146'),
					prop: 'rgnDt',
					width: '200px',
					align: 'center',
					sortable: false
				}
			];
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods
	}
};
</script>
<style></style>
